// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeZone__container-c25f25 {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 20px;
}

.TimeZone__title-f369a7 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.TimeZone__name-e27428 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/TimeZone/TimeZone.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n  margin-bottom: 20px;\n}\n\n.title {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.name {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TimeZone__container-c25f25`,
	"title": `TimeZone__title-f369a7`,
	"name": `TimeZone__name-e27428`
};
module.exports = ___CSS_LOADER_EXPORT___;
